<template>
    <div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
                <span>收货地址</span>
            </div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item>
                    <el-input size="" clearable v-model="formInline.userName" placeholder="请输入用户账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size="" clearable v-model="formInline.realName" placeholder="请输入用户真实姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size=""
                        v-model="formInline.addressType"
                        clearable
                        placeholder="请选择地址类型"
                    >
                        <el-option label="普通收货地址" value="0"></el-option>
                        <el-option label="默认收货地址" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <!-- 级联选择待定 -->
                    <el-select
                        size=""
                        v-model="formInline.city"
                        clearable
                        placeholder="请选择地址省/市"
                    >
                        <el-option label="已激活" value="0"></el-option>
                        <el-option label="未激活" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSubmit(formInline)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <!-- 占位 -->
            <!-- <div style="margin-bottom: 20px;"> -->
            <!-- <el-button size="small" type="primary" icon="el-icon-download" @click>数据导出</el-button> -->
            <!-- </div> -->
            <el-table
                :data="placeTable.list"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    prop="id"
                    label="ID"
                    min-width="100"
                ></el-table-column>
                <!-- 用户账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand"
                    label="用户账号"
                    min-width="120"
                ></el-table-column>
                <!-- 真实姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminalSn"
                    label="真实姓名"
                    min-width="200"
                ></el-table-column>
                <!-- 收货人姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminalId"
                    label="收货人姓名"
                    min-width="120"
                ></el-table-column>
                <!-- 联系电话 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchantId"
                    label="联系电话"
                    min-width="150"
                ></el-table-column>
                <!-- 所在地 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchantName"
                    label="所在地"
                    min-width="150"
                ></el-table-column>
                <!-- 详细地址 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchantNoteName"
                    label="详细地址"
                    min-width="100"
                ></el-table-column>
                <!-- 邮编 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchantPhone"
                    label="邮编"
                    min-width="150"
                ></el-table-column>
                <!-- 地址类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminalUserId"
                    label="地址类型"
                    min-width="150"
                ></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "UM_placeList",
    data() {
        return {
            search: '',
            formInline: {
                userName: '', //用户账号
                realName: '', //真实姓名
                addressType: '', //地址类型
                city: '', //省市
            },
            placeTable: {
                list: [],
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 100  //总数
            },
            loading: true
        }
    },
    mounted() {
        this.getTableList(this.page.currentPage, this.page.pageSize);
    },
    components: {
        paginations
    },
    methods: {
        onSubmit() {
            // 表单提交
            // this.$api.post(this.$port.organList, {}, res => {
            //     let data = res.data;
            //     this.paginations.total = data.count;
            //     this.placeTable.list = data.list;
            // })
        },
        //处理分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.loading = true;
            this.getTableList(this.page.currentPage, this.page.pageSize);
        },
        getPageSize(limit) {
            // 获取条数发生改变的值
            this.page.pageSize = limit;
            this.loading = true;
            this.getTableList(this.page.currentPage, limit);
        },
        getTableList(page, limit) {
            this.$api.post(this.$port.merchantList, { page, limit }, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.placeTable.list = data.list; //初始数据
                //渲染结束后取消加载
                this.loading = false;
            })
        }
    }
};
</script>

<style lang="scss" scope>
.el-input__inner {
    font-size: 12px;
}
.el-form-item {
    margin-bottom: 5px;
}
</style>
